import { JwtHost } from '@foodsby/webapp-jwt'
import * as Cookies from 'js-cookie'
import { sum } from 'lodash'

const CART = 'CART'
const domain = process.env.REACT_APP_COOKIE_DOMAIN
const jwtDomains = process.env.REACT_APP_JWT_DOMAIN

/**
 * Token Methods
 **/
let host
export const initTokens = () => {
  host = jwtDomains
    ? new JwtHost(jwtDomains.split(',').map(d => new RegExp(d)))
    : new JwtHost()
}
export const storeTokens = tokens => {
  host.storeTokens(tokens)
  Cookies.set(
    process.env.REACT_APP_COOKIE_NAME,
    { consumer: true },
    { secure: domain !== '', path: '/', domain }
  )
  tokens &&
    Cookies.set(process.env.REACT_APP_COOKIE_NAME + '-userId', tokens.user_id, {
      secure: domain !== '',
      path: '/',
      domain
    })
}
export const getAccessToken = () => host.getAccessToken()
export const getRefreshToken = () => host.getRefreshToken()
export const getDecodedAccessToken = () => host.getDecodedAccessToken()
export const isAccessTokenExpired = () => host.isAccessTokenExpired()
export const removeTokens = () => {
  host.removeTokens()
  Cookies.remove(process.env.REACT_APP_COOKIE_NAME, { path: '/', domain })
  Cookies.remove(process.env.REACT_APP_COOKIE_NAME + '-userId', {
    path: '/',
    domain
  })
}

/**
 * Cart Methods
 **/
export const addItemToLocalCart = (dropoffId, menuItem) => {
  const { id = 0, cart = [] } = JSON.parse(
    window.localStorage.getItem(CART) || '{}'
  )
  let newCart = []
  if (dropoffId === id) {
    newCart = [
      ...cart,
      {
        ...menuItem,
        orderItemId: cart.length + 1 // NOTE: orderItemId is faked
      }
    ]
  } else {
    newCart = [
      {
        ...menuItem,
        orderItemId: 1
      }
    ]
  }
  window.localStorage.setItem(
    CART,
    JSON.stringify({ id: dropoffId, cart: newCart })
  )
}

export const getLocalCart = dropoffId => {
  const { id = 0, cart = [] } = JSON.parse(
    window.localStorage.getItem(CART) || '{}'
  )
  if (id === dropoffId) {
    // format the cart
    return {
      orderItems: cart,
      itemSubTotal: sum(cart.map(c => c.fullSubTotal))
    }
  } else {
    return {
      orderItems: [],
      orderTotal: 0
    }
  }
}

export const deleteLocalCart = () => {
  window.localStorage.removeItem(CART)
}

export const removeItemFromLocalCart = (dropoffId, orderItemId) => {
  const { id = 0, cart = [] } = JSON.parse(
    window.localStorage.getItem(CART) || '{}'
  )
  let newCart = []
  if (dropoffId === id) {
    newCart = cart.filter(item => item.orderItemId !== orderItemId)
  }
  window.localStorage.setItem(
    CART,
    JSON.stringify({ id: dropoffId, cart: newCart })
  )
}

export const updateItemFromLocalCart = (dropoffId, menuItem, orderItemId) => {
  const { id = 0, cart = [] } = JSON.parse(
    window.localStorage.getItem(CART) || '{}'
  )
  let newCart = []
  if (dropoffId === id) {
    newCart = cart.map(item =>
      item.orderItemId === orderItemId
        ? {
            ...menuItem,
            orderItemId
          }
        : item
    )
  }
  window.localStorage.setItem(
    CART,
    JSON.stringify({ id: dropoffId, cart: newCart })
  )
}
